export const PILOT_MERCHANT_EMAILS = [
  "oniistoresc@gmail.com",
  "douglas.pena@grupoqtech.com.br"
];

// 28/08/2026 as 12:00 no horario de Brasilia (UTC-3).
export const PRODUCT_LOGS_NETWORK_RELEASE_AT = Date.UTC(2026, 7, 28, 15);

// 31/08/2026 as 12:00 no horario de Brasilia (UTC-3).
export const NEW_DASHBOARD_NETWORK_RELEASE_AT = Date.UTC(2026, 7, 31, 15);

export const isPilotMerchant = ownerInfo => {
  const email = String((ownerInfo && ownerInfo.email) || "")
    .trim()
    .toLowerCase();

  return PILOT_MERCHANT_EMAILS.includes(email);
};

export const canAccessProductLogs = (ownerInfo, now = Date.now()) => {
  return isPilotMerchant(ownerInfo) || now >= PRODUCT_LOGS_NETWORK_RELEASE_AT;
};

export const canAccessNewDashboard = (ownerInfo, now = Date.now()) => {
  return isPilotMerchant(ownerInfo) || now >= NEW_DASHBOARD_NETWORK_RELEASE_AT;
};
